/**
 * Check if an order matches the selected product type filters.
 *
 * Semantics:
 *   - Specific trait (e.g. "twarde"): ALL packages in the order must have that trait.
 *   - "Bez cechy" (-1): at least one package has no traits assigned.
 *   - Multiple specific traits selected: ALL packages must have at least one of the selected traits.
 *   - "Bez cechy" + specific trait: order matches if it satisfies either condition.
 *
 * @param {Object} order
 * @param {string[]} selectedProductTypes - array of ids as strings (e.g. ['-1', '2'])
 * @returns {boolean}
 */
export function matchesProductTypeFilter(order, selectedProductTypes) {
  if (selectedProductTypes.length === 0) return true;

  const hasNoTraits = selectedProductTypes.includes('-1');
  const otherTypes = selectedProductTypes.filter(id => id !== '-1');

  if (hasNoTraits) {
    const anyPackageHasNoTraits = order.packages?.some(pkg => !pkg.product?.productTypes?.length) ?? true;
    if (anyPackageHasNoTraits) return true;
  }

  if (otherTypes.length === 0) return false;

  const packages = order.packages ?? [];
  if (packages.length === 0) return false;

  // ALL packages must have at least one of the selected traits
  return packages.every(pkg =>
    pkg.product?.productTypes?.some(pt => otherTypes.includes(pt.id.toString()))
  );
}
